import AllRoutes from './component/AllRoutes';

import { Routes,Route } from "react-router-dom";
import { Homepage } from "./components/home";

import Calendar from './components1/Calendar';
import React from "react";

function App() {


  return (
    <div>

      <AllRoutes/>


      </div>
 
  );
}

export default App;
